import GeneralInfo from './GeneralInfo';

export default GeneralInfo;
